import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
var uuid = 0;
/**
 * Theme with algorithms to derive tokens from design tokens.
 * Use `createTheme` first which will help to manage the theme instance cache.
 */

var Theme = /*#__PURE__*/function () {
  function Theme(derivative) {
    _classCallCheck(this, Theme);

    this.derivative = void 0;
    this.id = void 0;
    this.derivative = derivative;
    this.id = uuid;
    uuid += 1;
  }

  _createClass(Theme, [{
    key: "getDerivativeToken",
    value: function getDerivativeToken(token) {
      return this.derivative(token);
    }
  }]);

  return Theme;
}(); // ================================== Cache ==================================


export { Theme as default };
var cacheThemes = new Map();
var MAX_CACHE_SIZE = 20;
var MAX_CACHE_OFFSET = 5;
var createTimes = 0;
/**
 * Same as new Theme, but will always return same one if `derivative` not changed.
 */

export function createTheme(derivative) {
  // Create new theme if not exist
  if (!cacheThemes.has(derivative)) {
    cacheThemes.set(derivative, [new Theme(derivative), 0]);
  } // Get theme from cache


  var cached = cacheThemes.get(derivative); // Refresh Call Time

  createTimes += 1;
  cached[1] = createTimes; // Clean up if cache is too large

  if (cacheThemes.size >= MAX_CACHE_SIZE + MAX_CACHE_OFFSET) {
    var latestThemes = Array.from(cacheThemes.keys()).sort(function (a, b) {
      var cacheA = cacheThemes.get(a);
      var cacheB = cacheThemes.get(b);
      return cacheB[1] - cacheA[1];
    }); // Remove earliest themes back count to MAX_CACHE_SIZE

    latestThemes.slice(MAX_CACHE_SIZE).forEach(function (key) {
      cacheThemes.delete(key);
    });
  }

  return cached[0];
}